(function () {
/* ============================================================
   CONFIG — all calculation data in one place
   ============================================================ */
const CONFIG = {
  price: 2599,
  mowsPerYear: { 'under-0.5': 30, '0.5-1': 26, '1-2': 30, '2+': 35 },
  areaValues: { 'under-0.5': 0.5, '0.5-1': 0.75, '1-2': 1.5, '2+': 2 },
  methods: {
    'walk-gas':      { name:'Walk-behind Mower', tag:'Gas',     eff:0.54, desc:'0.54 acre/hr',     buy:379,  e:{'under-0.5':133,'0.5-1':143,'1-2':285,'2+':368} },
    'walk-battery':  { name:'Walk-behind Mower', tag:'Battery', eff:0.52, desc:'0.52 acre/hr', buy:450,  e:{'under-0.5':99, '0.5-1':114,'1-2':234,'2+':432} },
    'riding-gas':    { name:'Riding Mower',      tag:'Gas',     eff:0.62, desc:'0.62 acre/hr',     buy:2400, e:{'under-0.5':266,'0.5-1':272,'1-2':310,'2+':481} },
    'riding-battery':{ name:'Riding Mower',      tag:'Battery', eff:0.74, desc:'0.74 acre/hr', buy:3450, e:{'under-0.5':294,'0.5-1':294,'1-2':139,'2+':358} },
    'zero-turn':     { name:'Zero-turn Mower',   tag:'',        eff:1.0,  desc:'1 acre/hr',              buy:4000, e:{'under-0.5':159,'0.5-1':249,'1-2':405,'2+':466} },
    'lawn-service':  { name:'Lawn Service',       tag:'',        eff:null, desc:'Professional weekly service', buy:0, e:{'under-0.5':1538,'0.5-1':1331,'1-2':2439,'2+':6469}, isService:true }
  }
};

const PAIN_LABELS = {
  'steep-slopes':'Steep slopes','uneven-ground':'Uneven ground','tree-roots':'Tree roots / bumps',
  'thick-grass':'Thick or tall grass','soft-muddy':'Soft or muddy ground','leaves-debris':'Leaves / yard debris',
  'kids-toys':'Kids toys / play areas','pets':'Pets in the yard','outdoor-furniture':'Outdoor furniture',
  'flower-beds':'Flower beds / garden beds','fences-walls':'Fences / AC units / walls','items-to-move':'Items to move before mowing',
  'narrow-side-yards':'Narrow side yards','multiple-zones':'Multiple lawn zones','tight-spaces':'Tight space around obstacles'
};
const PAIN_FEATURES = {
  'steep-slopes':    {f:'Terrain Master Traction', d:'Tracked treads conquer slopes up to 45° with stable, consistent traction.'},
  'uneven-ground':   {f:'Terrain Master Traction', d:'Stable tracked design handles rough, uneven terrain without scalping.'},
  'tree-roots':      {f:'Terrain Master Traction', d:'Glides over bumps and tree roots with low-center-of-gravity stability.'},
  'thick-grass':     {f:'Dual Rotary Blades',      d:'SK5 steel blades at 6000 RPM finely shred thick or tall grass.'},
  'soft-muddy':      {f:'Terrain Master Traction', d:'Low-ground-pressure tracks avoid ruts in soft or muddy ground.'},
  'leaves-debris':   {f:'Dual Rotary Blades',      d:'Cyclone airflow mulches leaves and yard debris into fine clippings.'},
  'kids-toys':       {f:'AI-Powered Obstacle Avoidance', d:'Computer vision detects toys and play areas in real time.'},
  'pets':            {f:'AI-Powered Obstacle Avoidance', d:'Vision + ultrasonic sensors detect pets and navigate around them safely.'},
  'outdoor-furniture':{f:'AI-Powered Obstacle Avoidance',d:'Seamlessly navigates around patio furniture — no moving required.'},
  'flower-beds':     {f:'Multi-Zone Smart Control',d:'Set no-go zones in the app; RTK precision keeps it out of garden beds.'},
  'fences-walls':    {f:'AI-Powered Obstacle Avoidance', d:'Detects fences, AC units and walls for collision-free mowing.'},
  'items-to-move':   {f:'AI-Powered Obstacle Avoidance', d:'No more pre-mowing cleanup — Lymow detects and avoids objects on its own.'},
  'narrow-side-yards':{f:'Wire-Free Smart Navigation',d:'RTK + VSLAM plans efficient paths through tight, narrow side yards.'},
  'multiple-zones':  {f:'Multi-Zone Smart Control',d:'Manage up to 80 custom zones and schedules from the mobile app.'},
  'tight-spaces':    {f:'AI-Powered Obstacle Avoidance', d:'Centimeter-level RTK precision + obstacle detection for tight spaces.'}
};
const ROI_CDN = 'https://cdn.shopify.com/s/files/1/0684/7715/7611/files/';
const CATEGORIES = [
  {id:'terrain',  name:'Terrain & Grass',     desc:'Slopes, bumps, thick growth', img: ROI_CDN + 'lymow-roi-cat-terrain.png?v=1789548355',
   pains:['steep-slopes','uneven-ground','tree-roots','thick-grass','soft-muddy','leaves-debris']},
  {id:'obstacles',name:'Obstacles & Objects', desc:'Toys, pets, furniture, beds', img: ROI_CDN + 'lymow-roi-cat-obstacles.png?v=1789548355',
   pains:['kids-toys','pets','outdoor-furniture','flower-beds','fences-walls','items-to-move']},
  {id:'layout',   name:'Layout & Navigation', desc:'Narrow yards, multiple zones', img: ROI_CDN + 'lymow-roi-cat-layout.png?v=1789548355',
   pains:['narrow-side-yards','multiple-zones','tight-spaces']}
];
const AREA_OPTS = [
  {id:'under-0.5', name:'Under 0.5', unit:'acres', img: ROI_CDN + 'lymow-roi-lawn-under-05.png?v=1789548355'},
  {id:'0.5-1',     name:'0.5 – 1',   unit:'acres', img: ROI_CDN + 'lymow-roi-lawn-05-1.png?v=1789548355'},
  {id:'1-2',       name:'1 – 2',     unit:'acres', img: ROI_CDN + 'lymow-roi-lawn-1-2.png?v=1789548355'},
  {id:'2+',        name:'2+',         unit:'acres', img: ROI_CDN + 'lymow-roi-lawn-2plus.png?v=1789548355'}
];
const MOWER_ICONS = {
  'walk-gas': `
    <svg width="25.3715" height="24.3136" viewBox="0 0 25.3715 24.3136" fill="none">
    <g>
    <path d="M14.4509 14.4507H2.09755C1.31783 14.4507 0.685737 15.0828 0.685737 15.8625V18.3332C0.685737 19.1129 1.31783 19.745 2.09755 19.745H14.4509C15.2306 19.745 15.8627 19.1129 15.8627 18.3332V15.8625C15.8627 15.0828 15.2306 14.4507 14.4509 14.4507Z" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.86152 23.6278C5.03111 23.6278 5.97924 22.6797 5.97924 21.5101C5.97924 20.3405 5.03111 19.3924 3.86152 19.3924C2.69194 19.3924 1.74381 20.3405 1.74381 21.5101C1.74381 22.6797 2.69194 23.6278 3.86152 23.6278Z" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.0359 23.6278C14.2055 23.6278 15.1536 22.6797 15.1536 21.5101C15.1536 20.3405 14.2055 19.3924 13.0359 19.3924C11.8663 19.3924 10.9182 20.3405 10.9182 21.5101C10.9182 22.6797 11.8663 23.6278 13.0359 23.6278Z" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.7442 14.4508L17.9796 5.62703H15.156" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.86211 11.6272H5.27373C4.68894 11.6272 4.21487 12.1013 4.21487 12.6861V13.392C4.21487 13.9768 4.68894 14.4508 5.27373 14.4508H9.86211C10.4469 14.4508 10.921 13.9768 10.921 13.392V12.6861C10.921 12.1013 10.4469 11.6272 9.86211 11.6272Z" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.2151 0.685737C21.1562 2.80345 19.7444 4.21526 19.7444 5.98003C19.7444 9.50956 24.6857 9.50956 24.6857 5.98003C24.6857 4.21526 23.2739 2.80345 22.2151 0.685737Z" stroke="#00ED89" stroke-width="1.37147" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `,
  'walk-battery': `
    <svg width="25.6" height="24.8941" viewBox="0 0 25.6 24.8941" fill="none">
    <g>
    <path d="M14.5647 14.9176H2.21176C1.43207 14.9176 0.8 15.5497 0.8 16.3294V18.8C0.8 19.5797 1.43207 20.2118 2.21176 20.2118H14.5647C15.3444 20.2118 15.9765 19.5797 15.9765 18.8V16.3294C15.9765 15.5497 15.3444 14.9176 14.5647 14.9176Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.97647 24.0941C5.14601 24.0941 6.09412 23.146 6.09412 21.9765C6.09412 20.8069 5.14601 19.8588 3.97647 19.8588C2.80693 19.8588 1.85882 20.8069 1.85882 21.9765C1.85882 23.146 2.80693 24.0941 3.97647 24.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.1529 24.0941C14.3225 24.0941 15.2706 23.146 15.2706 21.9765C15.2706 20.8069 14.3225 19.8588 13.1529 19.8588C11.9834 19.8588 11.0353 20.8069 11.0353 21.9765C11.0353 23.146 11.9834 24.0941 13.1529 24.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.8588 14.9176L18.0941 6.09412H15.2706" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.97647 12.0941H5.38824C4.80346 12.0941 4.32941 12.5682 4.32941 13.1529V13.8588C4.32941 14.4436 4.80346 14.9176 5.38824 14.9176H9.97647C10.5612 14.9176 11.0353 14.4436 11.0353 13.8588V13.1529C11.0353 12.5682 10.5612 12.0941 9.97647 12.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M23.7412 2.21176H20.9176C20.3329 2.21176 19.8588 2.68582 19.8588 3.27059V8.21176C19.8588 8.79654 20.3329 9.27059 20.9176 9.27059H23.7412C24.3259 9.27059 24.8 8.79654 24.8 8.21176V3.27059C24.8 2.68582 24.3259 2.21176 23.7412 2.21176Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.6235 0.8H23.0353M21.6235 4.68235H23.0353" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `,
  'riding-gas': `
    <svg width="25.6" height="24.5565" viewBox="0 0 25.6 24.5565" fill="none">
    <g>
    <path d="M4.27826 23.7565C6.00715 23.7565 7.4087 22.355 7.4087 20.6261C7.4087 18.8972 6.00715 17.4957 4.27826 17.4957C2.54937 17.4957 1.14783 18.8972 1.14783 20.6261C1.14783 22.355 2.54937 23.7565 4.27826 23.7565Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.2783 23.7565C21.4309 23.7565 22.3652 22.8222 22.3652 21.6696C22.3652 20.517 21.4309 19.5826 20.2783 19.5826C19.1257 19.5826 18.1913 20.517 18.1913 21.6696C18.1913 22.8222 19.1257 23.7565 20.2783 23.7565Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M0.8 16.8V14.3652H8.8L11.5826 17.4957H24.1043V14.0174C24.1043 12.9739 23.4087 12.6261 22.3652 12.6261H16.8L14.3652 17.4957M7.75652 20.6261H17.4957M4.27826 7.4087V10.887H8.45217M6.71304 10.887V14.3652M11.2348 15.0609L14.0174 9.49565M12.2783 8.45217L15.7565 10.1913" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.3652 0.8C21.3217 2.88696 19.9304 4.27826 19.9304 6.01739C19.9304 9.49565 24.8 9.49565 24.8 6.01739C24.8 4.27826 23.4087 2.88696 22.3652 0.8Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `,
  'riding-battery': `
    <svg width="25.6" height="24.8941" viewBox="0 0 25.6 24.8941" fill="none">
    <g>
    <path d="M14.5647 14.9176H2.21176C1.43207 14.9176 0.8 15.5497 0.8 16.3294V18.8C0.8 19.5797 1.43207 20.2118 2.21176 20.2118H14.5647C15.3444 20.2118 15.9765 19.5797 15.9765 18.8V16.3294C15.9765 15.5497 15.3444 14.9176 14.5647 14.9176Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.97647 24.0941C5.14601 24.0941 6.09412 23.146 6.09412 21.9765C6.09412 20.8069 5.14601 19.8588 3.97647 19.8588C2.80693 19.8588 1.85882 20.8069 1.85882 21.9765C1.85882 23.146 2.80693 24.0941 3.97647 24.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.1529 24.0941C14.3225 24.0941 15.2706 23.146 15.2706 21.9765C15.2706 20.8069 14.3225 19.8588 13.1529 19.8588C11.9834 19.8588 11.0353 20.8069 11.0353 21.9765C11.0353 23.146 11.9834 24.0941 13.1529 24.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.8588 14.9176L18.0941 6.09412H15.2706" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.97647 12.0941H5.38824C4.80346 12.0941 4.32941 12.5682 4.32941 13.1529V13.8588C4.32941 14.4436 4.80346 14.9176 5.38824 14.9176H9.97647C10.5612 14.9176 11.0353 14.4436 11.0353 13.8588V13.1529C11.0353 12.5682 10.5612 12.0941 9.97647 12.0941Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M23.7412 2.21176H20.9176C20.3329 2.21176 19.8588 2.68582 19.8588 3.27059V8.21176C19.8588 8.79654 20.3329 9.27059 20.9176 9.27059H23.7412C24.3259 9.27059 24.8 8.79654 24.8 8.21176V3.27059C24.8 2.68582 24.3259 2.21176 23.7412 2.21176Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.6235 0.8H23.0353M21.6235 4.68235H23.0353" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `,
  'zero-turn': `
    <svg width="25.6" height="20.8676" viewBox="0 0 25.6 20.8676" fill="none">
    <g>
    <path d="M4.18028 20.0676C5.86047 20.0676 7.22254 18.7056 7.22254 17.0254C7.22254 15.3452 5.86047 13.9831 4.18028 13.9831C2.50009 13.9831 1.13803 15.3452 1.13803 17.0254C1.13803 18.7056 2.50009 20.0676 4.18028 20.0676Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.7296 20.0676C20.663 20.0676 21.4197 19.3109 21.4197 18.3775C21.4197 17.444 20.663 16.6873 19.7296 16.6873C18.7961 16.6873 18.0394 17.444 18.0394 18.3775C18.0394 19.3109 18.7961 20.0676 19.7296 20.0676Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.23662 2.82819H4.18028C3.43353 2.82819 2.82817 3.43355 2.82817 4.1803V7.22255C2.82817 7.9693 3.43353 8.57466 4.18028 8.57466H8.23662C8.98337 8.57466 9.58873 7.9693 9.58873 7.22255V4.1803C9.58873 3.43355 8.98337 2.82819 8.23662 2.82819Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.20845 8.57468V10.9409M0.8 13.3071V10.9409H9.92676L13.9831 14.9972H23.4479V16.6874M7.89859 17.0254H15.3352M12.631 12.293V7.22257L14.6592 5.87045M17.3634 0.80003C22.4338 1.13806 24.8 5.53242 22.7718 9.92679M20.7437 8.57468L22.7718 10.6028L24.8 8.23665" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `,
  'lawn-service': `
    <svg width="25.6" height="17.7766" viewBox="0 0 25.6 17.7766" fill="none">
    <g>
    <path d="M14.5647 0.8H1.85882C1.27405 0.8 0.8 1.27405 0.8 1.85882V10.6824C0.8 11.2671 1.27405 11.7412 1.85882 11.7412H14.5647C15.1495 11.7412 15.6235 11.2671 15.6235 10.6824V1.85882C15.6235 1.27405 15.1495 0.8 14.5647 0.8Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.6235 4.32956H20.9176L24.8 8.56485V11.7413H15.6235" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.03529 16.9766C6.20484 16.9766 7.15294 16.0285 7.15294 14.859C7.15294 13.6894 6.20484 12.7413 5.03529 12.7413C3.86575 12.7413 2.91765 13.6894 2.91765 14.859C2.91765 16.0285 3.86575 16.9766 5.03529 16.9766Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.9176 16.9766C22.0872 16.9766 23.0353 16.0285 23.0353 14.859C23.0353 13.6894 22.0872 12.7413 20.9176 12.7413C19.7481 12.7413 18.8 13.6894 18.8 14.859C18.8 16.0285 19.7481 16.9766 20.9176 16.9766Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.15256 14.859H18.4467M6.79962 9.62367L9.2702 6.80014M7.85844 8.56485C4.32903 8.21191 4.68197 3.62367 11.3879 3.62367C11.7408 7.85897 10.329 9.27073 7.85844 8.56485Z" stroke="#00ED89" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
  `
};

if (window.LymowRoiAssets) {
  CATEGORIES.forEach(function (c) {
    if (window.LymowRoiAssets.cats && window.LymowRoiAssets.cats[c.id]) c.img = window.LymowRoiAssets.cats[c.id];
  });
  AREA_OPTS.forEach(function (o) {
    if (window.LymowRoiAssets.lawns && window.LymowRoiAssets.lawns[o.id]) o.img = window.LymowRoiAssets.lawns[o.id];
  });
}

/* ============================================================
   STATE
   ============================================================ */
const state = { step:1, method:null, area:null, pains:new Set(), email:'' };
const MAX_PAINS = 6;
let autoTimer = null;
let countdownTimer = null;
let submitted = false;

const $ = id => document.getElementById(id);
const viewId = n => ['step1','step2','step3','step4','report'][n-1];
const COPY = Object.assign({
  counter: '[n] / [max] selected',
  catSelected: '[count] selected',
  hoverHint: 'Hover to see issues',
  tapHint: 'Tap to see issues',
  tapSelect: 'Tap to select ↓',
  chipsHint: 'Tap to select all that apply',
  moneyLabel: 'Money Saved Per Year',
  timeLabel: 'Time Reclaimed Per Year',
  perYear: '/yr',
  hrsYear: 'hrs/yr',
  solutionsTitle: 'Your frustrations, solved by Lymow',
  footerHint: '*Data calculated based on industry averages and Lymow survey data. Actual values may vary due to different lawn environments and personal habits.',
  copyCode: 'Copy code',
  copied: 'Copied',
  emailError: 'Please enter a valid email',
  reportSummary: 'Based on [method] · [area] acres.'
}, window.LymowRoiCopy || {});
function escHtml(s){
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
function isFineHover(){
  return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
if (!$('banner-cta') || !$('roi-modal')) return;

/* ============================================================
   CALC
   ============================================================ */
function calc(){
  const m = CONFIG.methods[state.method];
  const E = m.e[state.area];
  const F = m.buy;
  const costSaving = E + F;
  let timeHrs = null, singleMow = null;
  if(!m.isService){
    const acres = CONFIG.areaValues[state.area];
    const mows = CONFIG.mowsPerYear[state.area];
    singleMow = acres / m.eff;
    timeHrs = singleMow * mows;
  }
  const paybackYrs = CONFIG.price / costSaving;
  return {m, E, F, costSaving, timeHrs, singleMow, paybackYrs, isService:!!m.isService};
}
function fmtPayback(yrs){
  const total = Math.round(yrs * 12);
  if(total < 12){
    return {text: total + ' month' + (total>1?'s':''), months: total};
  }
  const y = Math.floor(total / 12), mo = total % 12;
  return {text: y + ' yr' + (y>1?'s':'') + (mo ? ' ' + mo + ' mo' : ''), months: total};
}

/* ============================================================
   AUTO-ADVANCE
   ============================================================ */
function clearAuto(){
  if(autoTimer){ clearTimeout(autoTimer); autoTimer = null; }
  const bar = $('auto-bar');
  if(bar){ bar.style.transition = 'none'; bar.style.width = '0%'; }
}
function startAuto(delay, target){
  clearAuto();
  const bar = $('auto-bar');
  bar.style.transition = 'none';
  bar.style.width = '100%';
  void bar.offsetWidth;
  bar.style.transition = 'width ' + delay + 'ms linear';
  bar.style.width = '0%';
  autoTimer = setTimeout(() => { clearAuto(); advanceTo(target); }, delay);
}
function advanceTo(n){
  clearAuto();
  const cur = $('view-' + viewId(state.step));
  cur.classList.add('leaving');
  setTimeout(() => {
    cur.classList.remove('leaving');
    showStep(n);
    const next = $('view-' + viewId(n));
    next.classList.add('entering');
    setTimeout(() => next.classList.remove('entering'), 40);
  }, 250);
}

/* ============================================================
   RENDER STEP 1
   ============================================================ */
function renderStep1(){
  const grid = $('step1-grid');
  grid.innerHTML = '';
  Object.entries(CONFIG.methods).forEach(([id, m]) => {
    const card = document.createElement('div');
    card.className = 'opt-card' + (state.method===id ? ' selected' : '');
    const desc = m.desc || '';
    card.innerHTML = `
      <div class="opt-icon">${MOWER_ICONS[id]||''}</div>
      <div class="opt-text">
        <div class="opt-name">${m.name}${m.tag?' <span style="color:var(--muted);font-weight:400;font-size:12px">· '+m.tag+'</span>':''}</div>
        <div class="opt-desc">${desc}</div>
      </div>
      <div class="opt-check"></div>`;
    card.addEventListener('click', () => {
      state.method = id;
      renderStep1();
      setTimeout(() => advanceTo(2), 420);
    });
    grid.appendChild(card);
  });
}

/* ============================================================
   RENDER STEP 2
   ============================================================ */
function renderStep2(){
  const grid = $('step2-grid');
  grid.innerHTML = '';
  AREA_OPTS.forEach(o => {
    const card = document.createElement('div');
    card.className = 'area-card' + (state.area===o.id ? ' selected' : '');
    card.innerHTML = `
      <div class="area-vis"><img src="${o.img}" width="100" height="53" alt=""></div>
      <div class="area-name">${o.name}</div>
      <div class="area-unit">${o.unit}</div>`;
    card.addEventListener('click', () => {
      state.area = o.id;
      renderStep2();
      setTimeout(() => advanceTo(3), 420);
    });
    grid.appendChild(card);
  });
}

/* ============================================================
   RENDER STEP 3  (incremental — no full re-render on chip click)
   ============================================================ */
function renderStep3(){
  const list = $('step3-list');
  list.innerHTML = '';
  CATEGORIES.forEach(cat => {
    const wrap = document.createElement('div');
    wrap.className = 'pain-cat expanded';
    wrap.dataset.cat = cat.id;
    const chips = cat.pains.map(p => {
      const selected = state.pains.has(p);
      return `<span class="pain-chip${selected?' selected':''}" data-pain="${p}">${PAIN_LABELS[p]}</span>`;
    }).join('');
    wrap.innerHTML = `
      <div class="cat-head">
        <img src="${cat.img}" alt="${cat.name}" loading="lazy">
        <div class="cat-info">
          <div>
            <div class="cat-name">${cat.name}</div>
            <div class="cat-desc">${cat.desc}</div>
          </div>
          <div style="display:flex;align-items:center;gap:10px">
            <span class="cat-badge">${escHtml((isFineHover() ? COPY.hoverHint : COPY.tapHint) || '')}</span>
            <svg class="cat-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
          </div>
        </div>
      </div>
      <div class="pain-chips">
        ${COPY.chipsHint ? `<div class="pain-chips-hint">${escHtml(COPY.chipsHint)}</div>` : ''}
        ${chips}</div>`;
    if (isFineHover()) {
      wrap.addEventListener('mouseenter', () => {
        wrap.classList.add('expanded');
        updateAllCatBadges();
      });
    }
    wrap.querySelector('.cat-head').addEventListener('click', () => {
      wrap.classList.toggle('expanded');
      updateAllCatBadges();
    });
    /* chip click — incremental update only */
    wrap.querySelectorAll('.pain-chip').forEach(chip => {
      chip.addEventListener('click', e => {
        e.stopPropagation();
        const p = chip.dataset.pain;
        if(state.pains.has(p)){
          state.pains.delete(p);
          chip.classList.remove('selected');
        } else if(state.pains.size < MAX_PAINS){
          state.pains.add(p);
          chip.classList.add('selected');
        }
        updatePainCounter();
        updateAllCatBadges();
        updateDisabledChips();
      });
    });
    list.appendChild(wrap);
  });
  updatePainCounter();
  updateAllCatBadges();
  updateDisabledChips();
}
function updatePainCounter(){
  const el = $('pain-counter');
  if (!el) return;
  if (!COPY.counter) {
    el.hidden = true;
    return;
  }
  el.hidden = false;
  el.textContent = String(COPY.counter).replace('[n]', state.pains.size).replace('[max]', MAX_PAINS);
  el.classList.toggle('has', state.pains.size > 0);
  el.classList.toggle('max', state.pains.size >= MAX_PAINS);
}
function updateAllCatBadges(){
  document.querySelectorAll('.lrc-roi .pain-cat').forEach(wrap => {
    const cat = CATEGORIES.find(c => c.id === wrap.dataset.cat);
    const count = cat.pains.filter(p => state.pains.has(p)).length;
    const badge = wrap.querySelector('.cat-badge');
    const isExpanded = wrap.classList.contains('expanded');
    if(count > 0){
      badge.textContent = COPY.catSelected ? String(COPY.catSelected).replace('[count]', count) : '';
    } else if(isExpanded){
      badge.textContent = COPY.tapSelect || '';
    } else {
      badge.textContent = (isFineHover() ? COPY.hoverHint : COPY.tapHint) || '';
    }
    badge.hidden = !badge.textContent;
    badge.classList.toggle('has', count > 0);
  });
}
function updateDisabledChips(){
  const maxed = state.pains.size >= MAX_PAINS;
  document.querySelectorAll('.lrc-roi .pain-chip').forEach(chip => {
    if(!chip.classList.contains('selected')) chip.classList.toggle('disabled', maxed);
  });
}

/* ============================================================
   COUNT-UP ANIMATION
   ============================================================ */
function animateNumber(el, target, formatter, duration){
  duration = duration || 1400;
  const start = performance.now();
  function tick(now){
    const t = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    el.innerHTML = formatter(target * eased);
    if(t < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

/* ============================================================
   RENDER REPORT
   ============================================================ */
function renderReport(){
  const r = calc();
  const areaName = AREA_OPTS.find(a => a.id === state.area)?.name || state.area;
  const methodLabel = r.m.name + (r.m.tag?' ('+r.m.tag+')':'');
  const summaryEl = $('report-summary');
  if (summaryEl) {
    if (COPY.reportSummary) {
      summaryEl.hidden = false;
      summaryEl.textContent = String(COPY.reportSummary).replace('[method]', methodLabel).replace('[area]', areaName);
    } else {
      summaryEl.hidden = true;
      summaryEl.textContent = '';
    }
  }

  const pb = fmtPayback(r.paybackYrs);
  const showPayback = r.paybackYrs < 2;

  /* ---- Metric cards: display rules per mower type (final decision) ----
     Lawn Service   → Money + Payback (no Time)
     Riding & Zero-turn → Money + Time + Payback
     Walk-behind    → Money + Time (no Payback, payback always >2 yrs)   */
  const isWalk = state.method.indexOf('walk') === 0;
  const showTime = !r.isService;
  const showPaybackFinal = !isWalk && showPayback;
  const singleCard = !showTime;
  $('report-metrics').classList.toggle('is-single', singleCard);

  let metricsHtml = `<div class="metric${singleCard?' single':''}"><div class="metric-label">${escHtml(COPY.moneyLabel)}</div><div class="metric-value" id="anim-cost">$0</div></div>`;
  if(showTime){
    metricsHtml += `<div class="metric"><div class="metric-label">${escHtml(COPY.timeLabel)}</div><div class="metric-value" id="anim-time">0</div></div>`;
  }
  $('report-metrics').innerHTML = metricsHtml;

  animateNumber($('anim-cost'), r.costSaving, v => '$' + Math.round(v).toLocaleString('en-US') + '*<span style="font-size:20px;color:var(--muted)">' + escHtml(COPY.perYear) + '</span>');
  if(showTime){
    animateNumber($('anim-time'), r.timeHrs, v => Math.round(v) + '*<span style="font-size:20px;color:var(--muted)"> ' + escHtml(COPY.hrsYear) + '</span>');
  }

  /* ---- Payback bar (walk-behind never; others only if payback < 2 yrs) ---- */
  const pbWrap = $('payback-bar-wrap');
  if(showPaybackFinal){
    pbWrap.classList.remove('hidden');
    const pct = Math.min(100, (r.paybackYrs / 2) * 100);
    $('pb-label-right').innerHTML = '<span style="font-size:22px;font-weight:900;color:var(--accent);letter-spacing:-.3px">' + pb.text + '</span>';
    const fill = $('payback-fill');
    fill.style.width = '0%';
    requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = pct + '%'; }));
  } else {
    pbWrap.classList.add('hidden');
  }

  /* solutions */
  const solWrap = $('report-solutions');
  if(state.pains.size > 0){
    const byFeature = {};
    state.pains.forEach(p => {
      const f = PAIN_FEATURES[p];
      if(!f) return;
      if(!byFeature[f.f]) byFeature[f.f] = {d:f.d, pains:[]};
      byFeature[f.f].pains.push(PAIN_LABELS[p]);
    });
    const cards = Object.entries(byFeature).slice(0,4).map(([fname, data]) => `
      <div class="sol-card">
        <div class="sol-feature">${fname}</div>
        <div class="sol-desc">${data.d}</div>
        <div class="sol-pains">${data.pains.map(p=>'<span class="sol-pain">'+p+'</span>').join('')}</div>
      </div>`).join('');
    solWrap.innerHTML = (COPY.solutionsTitle ? `<div class="solutions-title">${escHtml(COPY.solutionsTitle)}</div>` : '') + `<div class="sol-grid">${cards}</div>`;
  } else { solWrap.innerHTML = ''; }

  /* SAVE30 coupon — always shown; copy the code to use, no auto-email (per decision) */
  $('coupon-reveal').style.display = 'block';
  startCountdown();
  submitToMetaobject(r);
}

function captureEmailFromInput(){
  var input = $('email-input');
  if (!input) return;
  var val = input.value.trim();
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
    state.email = val;
  }
}

function submitToMetaobject(r){
  if (submitted) return;
  var cfg = window.LymowRoiSubmit;
  if (!cfg || !cfg.metaobjectType || !cfg.gqlMutation) return;
  if (!state.method || !state.area || !r) return;
  captureEmailFromInput();
  submitted = true;

  var areaOpt = AREA_OPTS.find(function (a) { return a.id === state.area; });
  var areaLabel = areaOpt ? (areaOpt.name + ' ' + areaOpt.unit) : String(state.area);
  var methodLabel = r.m.name + (r.m.tag ? ' · ' + r.m.tag : '');
  var painLabels = [];
  state.pains.forEach(function (p) {
    painLabels.push(PAIN_LABELS[p] || p);
  });
  var pb = fmtPayback(r.paybackYrs);
  var metaFields = [
    { key: 'how_do_you_mow_today', value: methodLabel },
    { key: 'how_large_is_your_lawn', value: areaLabel },
    { key: 'what_makes_mowing_frustrating', value: painLabels.length ? painLabels.join(', ') : 'None' },
    { key: 'email', value: state.email || 'skipped' },
    { key: 'money_saved_per_year', value: '$' + Math.round(r.costSaving).toLocaleString('en-US') + '/yr' },
    { key: 'time_reclaimed_per_year', value: (!r.isService && r.timeHrs != null) ? (Math.round(r.timeHrs) + ' hrs/yr') : 'N/A' },
    { key: 'time_to_break_even', value: pb && pb.text ? pb.text : 'N/A' }
  ];

  var entryHandle = 'roi-v2-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  var payload = {
    query: cfg.gqlMutation,
    variables: {
      metaobject: { type: cfg.metaobjectType, handle: entryHandle, fields: metaFields }
    }
  };
  console.log('[LRC submit body]', payload);

  var url = cfg.apiEndpoint || 'https://lymow.ou-chaohui.workers.dev/api/proxy-shopify';
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(payload)
  })
    .then(function (res) { return res.text().then(function (text) { return { res: res, text: text }; }); })
    .then(function (out) {
      var json = {};
      try { json = out.text ? JSON.parse(out.text) : {}; } catch (e) { json = {}; }
      var user = json.data && json.data.metaobjectCreate && json.data.metaobjectCreate.userErrors;
      if (!out.res.ok || json.errors || (user && user.length) || !json.data) {
        console.error('[LRC submit failed]', out.res.status, json);
        submitted = false;
      } else {
        console.log('[LRC submit ok]', json);
      }
    })
    .catch(function (err) {
      console.error('[LRC submit error]', err);
      submitted = false;
    });
}

/* ============================================================
   COUNTDOWN
   ============================================================ */
function startCountdown(){
  let total = 15 * 60;
  const el = $('countdown-timer');
  if(countdownTimer) clearInterval(countdownTimer);
  function tick(){
    const m = Math.floor(total / 60), s = total % 60;
    el.textContent = String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
    if(total <= 0){ clearInterval(countdownTimer); return; }
    total--;
  }
  tick();
  countdownTimer = setInterval(tick, 1000);
}

/* ============================================================
   NAV / MODAL
   ============================================================ */
function showStep(n){
  state.step = n;
  ['step1','step2','step3','step4','report'].forEach((v,i) => {
    $('view-'+v).classList.toggle('hidden', (i+1) !== n);
  });
  const pct = n <= 4 ? (n/4)*100 : 100;
  $('progress-fill').style.width = pct + '%';
  document.querySelectorAll('.lrc-roi .progress-step').forEach((el,i) => {
    el.classList.toggle('active', i+1 === n);
    el.classList.toggle('done', i+1 < n);
  });
  $('modal-footer').style.display = (n === 5) ? 'none' : 'flex';
  $('modal-footer').classList.toggle('is-step3', n === 3);
  $('step3-actions').hidden = n !== 3;
  $('auto-bar').style.display = (n === 3 || n === 4 || n === 5) ? 'none' : '';
  if(n===1) renderStep1();
  if(n===2) renderStep2();
  if(n===3) renderStep3();
  if(n===5) renderReport();
  updateNav();
  var bodyEl = $('roi-modal-body');
  if (bodyEl) bodyEl.scrollTop = 0;
}
function updateNav(){
  const back = $('btn-back'), hint = $('nav-hint');
  back.disabled = (state.step <= 1);
  if(state.step === 1) hint.textContent = COPY.footerHint || '';
  else hint.textContent = '';
}

function openModal(){
  submitted = false;
  $('roi-modal').classList.add('show');
  document.body.style.overflow = 'hidden';
  showStep(1);
}
function closeModal(){
  clearAuto();
  if(countdownTimer) clearInterval(countdownTimer);
  submitted = false;
  $('roi-modal').classList.remove('show');
  document.body.style.overflow = '';
}

/* ============================================================
   EVENTS
   ============================================================ */
$('banner-cta').addEventListener('click', openModal);
$('modal-close').addEventListener('click', closeModal);
$('modal-backdrop').addEventListener('click', closeModal);
$('btn-back').addEventListener('click', () => {
  if(state.step > 1 && state.step <= 4){ clearAuto(); showStep(state.step - 1); }
});
if ($('step3-skip')) $('step3-skip').addEventListener('click', () => { clearAuto(); advanceTo(4); });
$('step3-next').addEventListener('click', () => { clearAuto(); advanceTo(4); });
$('footer-continue').addEventListener('click', () => { clearAuto(); advanceTo(4); });
if ($('email-skip')) $('email-skip').addEventListener('click', () => { clearAuto(); advanceTo(5); });
$('email-submit').addEventListener('click', submitEmail);
$('email-input').addEventListener('keydown', e => { if(e.key === 'Enter') submitEmail(); });
$('email-input').addEventListener('input', () => {
  $('email-input').classList.remove('error');
});
$('btn-retake').addEventListener('click', () => {
  state.method = null; state.area = null; state.pains.clear();
  state.email = '';
  submitted = false;
  $('email-input').value = '';
  var copyBtn = $('coupon-copy');
  if (copyBtn) {
    copyBtn.textContent = COPY.copyCode;
    copyBtn.classList.remove('is-copied');
  }
  showStep(1);
});
if ($('coupon-copy')) $('coupon-copy').addEventListener('click', function () {
  var codeEl = document.querySelector('.lrc-roi .coupon-reveal-code');
  var code = (codeEl && codeEl.textContent.trim()) || 'SAVE30';
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code);
  }
  this.textContent = COPY.copied;
  this.classList.add('is-copied');
});

function submitEmail(){
  const input = $('email-input');
  const val = input.value.trim();
  const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  if(!ok){ input.classList.add('error'); input.placeholder = COPY.emailError; return; }
  input.classList.remove('error');
  state.email = val;
  clearAuto();
  advanceTo(5);
}

/* ESC to close */
document.addEventListener('keydown', e => { if(e.key === 'Escape' && $('roi-modal') && $('roi-modal').classList.contains('show')) closeModal(); });
})();
